try {
  if (document.querySelector(".lunch-section__right")) {
    window.addEventListener(
      "load",
      event => {
        let startAt = 0;
        let now = new Date();
        let dayItems = document.querySelectorAll(
          ".lunch-section__right--slide .glide__slides li"
        );
        dayItems.forEach((dayItem, index) => {
          if (parseInt(dayItem.dataset["day"]) === now.getDay()) {
            startAt = index;
          }
        });

        const defaultOptions = {
          type: "carousel",
          startAt,
          perView: 1
        };

        const textSlider = new Glide(
          ".lunch-section__right--image-medium .glide",
          defaultOptions
        ).mount();

        const images = document.querySelectorAll(
          ".lunch-section__right--image-medium img"
        );

        // initialize image slider after all images has been loaded
        const imageSlider = new Glide(
          ".lunch-section__right--slide .glide",
          defaultOptions
        ).mount();

        const badgeSlider = new Glide(
          ".lunch-section__right--badge .glide",
          defaultOptions
        ).mount();

        const syncGlide = (master, slave) => {
          master.on("run", function(e) {
            if (e.direction === "=") {
              slave.go(`${e.direction}${e.steps}`);
            } else {
              slave.go(e.direction);
            }
          });
        };

        syncGlide(textSlider, imageSlider);
        syncGlide(imageSlider, textSlider);
        syncGlide(textSlider, badgeSlider);
        syncGlide(badgeSlider, textSlider);
      },
      1000
    );
  }
} catch (e) {
  console.log(e);
}
